export default __webpack_public_path__ + "static/media/Background_00041.8e3f356a.png";